import { useTranslation } from 'react-i18next';
import { useOrderByColumn } from './useOrderByColumn';

/**
 * This hook returns the text name of the column that is currently being ordered by.
 */
export const useOrderByColumnTextName = ({ orderBy, allColumnList }) => {
  const column = useOrderByColumn({ orderBy, allColumnList });
  const [t] = useTranslation('search');
  return (
    t(column?.name || '') || t(column?.fieldName || '') || t(column?.key || '')
  );
};
